import { useHasAdminRole } from "services/auth/useHasAdminRole";
import { Privilege } from "services/rbac/types";

import { useAccessManager } from "components/App/accessManager";
import { ErrorScreen, ErrorScreenImagePosition } from "components/ErrorScreen";
import { NoAccess } from "components/Icons";

export enum PrivilegesMatchStrategy {
  EVERY = "every",
  SOME = "some",
}

export const Restricted = (
  props: React.PropsWithChildren<{
    privileges: Array<Privilege>;
    matchStrategy?: PrivilegesMatchStrategy;
    bypassOrgAdmin?: boolean;
  }>
) => {
  const {
    privileges,
    children,
    matchStrategy = PrivilegesMatchStrategy.EVERY,
    bypassOrgAdmin,
  } = props;

  const hasOrganizationAdminRole = useHasAdminRole();
  const { isAllowedTo } = useAccessManager();
  const privilegeMatch = (privilege: Privilege) =>
    isAllowedTo(
      privilege.objectType,
      privilege.objectName,
      privilege.privilegeType
    );

  if (bypassOrgAdmin && hasOrganizationAdminRole) {
    return <>{children}</>;
  }

  if (privileges.length && !privileges[matchStrategy](privilegeMatch)) {
    return (
      <ErrorScreen
        title="Access Denied"
        description="It seems you don’t currently have the access to this page.
      Contact your administrator for advice."
        image={<NoAccess />}
        imagePosition={ErrorScreenImagePosition.Top}
      />
    );
  }
  return <>{children}</>;
};
